module.exports = __webpack_public_path__ + "img/xyy.bad4ec94.png";